import "babel-polyfill";
import Vue from "vue";
import Vuetify from "vuetify";
import VueResource from "vue-resource";
import VueRouter from "vue-router";
import VueCookies from "vue-cookies";
import Meta from "vue-meta";
import App from "./App";
import Login from "./Login";
import MecanicaApp from "./MecanicaApp";

import "vuetify/dist/vuetify.min.css";

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(Vuetify);
Vue.use(Meta);

const AppView = { template: "<App />", components: { App } };
const LoginView = { template: "<Login />", components: { Login } };
const MecanicaAppView = { template: "<MecanicaApp />", components: { MecanicaApp } };

const routes = [
  { path: "/notes*", component: AppView },
  { path: "/sign_in", component: LoginView },
  { path: "/*", component: MecanicaAppView }
];

const router = new VueRouter({
  routes
});

// https://router.vuejs.org/guide/#javascript
const app = new Vue({
  router
})

app.base_url = 'https://api.paludetto.dev.br'

app.$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js